import { fetchAuthSession } from "aws-amplify/auth";

export async function getTokenData() {
  try {
    const session = await fetchAuthSession({ forceRefresh: false });
    const payload = session?.tokens?.idToken?.payload || {};

    return {
      token: session?.tokens?.accessToken?.toString() || null,
      client_id: session?.tokens?.idToken?.toString() || null,
      email: payload.email || null,
    };
  } catch (err) {
    console.error("Erro ao obter sessão:", err);

    return {
      token: null,
      client_id: null,
      email: null,
    };
  }
}
